<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoading">
    <div id="page" class="connections-wrapper">

        <div class="connections-header">
            <div class="header-text" *ngIf="connections.length === 0">No flight connections yet</div>
            <div class="header-text" *ngIf="connections.length > 0">Your flight connections</div>
        </div>

        <app-tab-bar [tabs]="connectionTabs" [activeTab]="tabView"></app-tab-bar>
    
        <div class="connections-results">

            <!-- CONFIRMED -->
            <ng-container *ngIf="tabView === 'connected flights'">

                <ng-container *ngIf="upcomingConnections.length === 0; else upcomingTemplate">
                    <app-empty-state-card mt="24px" messageText="Your confirmed connections will appear here"></app-empty-state-card>
                </ng-container>

                <ng-template #upcomingTemplate>
                    <div class="list-label">
                        Upcoming: {{upcomingConnections.length}}
                    </div>
                    <app-flight-connection-card *ngFor="let c of upcomingConnections" [connection]="c" (click)="onClickConnection(c)"></app-flight-connection-card>
                </ng-template>

                <ng-container *ngIf="pastConnections.length > 0">
                    <div class="list-label">
                        History: {{pastConnections.length}}
                    </div>
                    <app-flight-connection-card *ngFor="let c of pastConnections" [connection]="c" (click)="onClickConnection(c)"></app-flight-connection-card>
                </ng-container>

            </ng-container>

             <!-- REQUESTS -->
            <ng-container *ngIf="tabView === 'requests'">
                
                <ng-container *ngIf="pendingConnections.length === 0, else requestsTemplate">
                    <app-empty-state-card mt="24px" messageText="You don't have any requests right now"></app-empty-state-card>
                </ng-container>

                <ng-template #requestsTemplate>
                    <div class="list-label">
                        {{pendingConnections.length}} Request{{pendingConnections.length > 1 ? 's':''}} to Review
                    </div>
                    <app-flight-connection-card *ngFor="let c of pendingConnections" [connection]="c" (click)="onClickConnection(c)"></app-flight-connection-card>
                </ng-template>

            </ng-container>
    
            <!-- SUPER EMPTY STATE -->
             
            <!-- <ng-container *ngIf="pendingConnections?.length === 0 && confirmedConnections?.length === 0">
                <app-empty-state-card messageText="Chat with Agent find parties to share flights"></app-empty-state-card>
            </ng-container> -->
    
        </div>
    
    </div>
</app-page-wrapper>